/**
 * Contains a dictionary with translations for all
 * user facing strings that's in some way or form presented by Javascript
 */
define(
    'strings',[], function () {
        if (window.i18n) {
            return window.i18n;
        }

        return {
            'en':  {
                'pcs': 'pcs',
                'Loading...': 'Loading...',
                'View more': 'View more',

                'Are you sure that you what to delete logo?': 'Are you sure that you what to delete logo?', // Confirmation to delete logo

                'Cancel': 'Cancel', // CTA Cancel
                'Delete': 'Delete', // CTA Delete
                'Logo is saved': 'Logo is saved', // Success msg after user press save btn
                'Products': 'Products',

                // Prompts
                'Caution': 'Caution',
                'Setting the quantity of an item to zero (0) will remove it.': 'Setting the quantity of an item to zero (0) will remove it.',

                // Errors
                'Not an accepted file type': 'Not an accepted file type.',
                'Filesize is too big': 'Filesize is too big. Max size is 1Mb.',
                'Image cannot be uploaded. Please try later or another image.': 'Image cannot be uploaded. Please try later or another image.',
                'Logo cannot be deleted. Please try later.': 'Logo cannot be deleted. Please try later.',
                'An error occured, please try again later.': 'An error occured, please try again later.', // Standart error message
                'Your order is placed to cart.': 'Your order is placed to cart.',
                'Failed to load price for product "%s"': 'Failed to load price for product "%s"',
                'Failed to load price.': 'Failed to load price.',
                'Failed to load product.': 'Failed to load product.',
                'Failed to load product image': 'Failed to load product image',
                'Failed to load products, please try again later.': 'Failed to load products, please try again later.',
                'Price not available': 'Price not available',
                'Failed to synchronize with server. Please try once more or contact our customer service.': 'Failed to synchronize with server. Please try once more or contact our customer service.',
                'Failed to load any search suggestions.': 'Failed to load any search suggestions.',
                'Failed to load offers.': 'Failed to load offers.',
                'Unable to delete this offer.': 'Unable to delete this offer.',
                'Failed to load orders.': 'Failed to load orders.',
                'Failed to select product. Please try again later or contact the customer service.': 'Failed to select product. Please try again later or contact the customer service.',
                'Something went wrong trying to apply your changes. Please try again or the customer service.': 'Something went wrong trying to apply your changes. Please try again or the customer service.',
                'An unexpected error occurred. Please try again or contact the customer service.': 'An unexpected error occurred. Please try again or contact the customer service.',
                'Failed to remove item. Please try again or contact the customer service.':'Failed to remove item. Please try again or contact the customer service.',
                'An unexpected error occurred when trying to update application cost.': 'An unexpected error occurred when trying to update application cost.',
                'No image available': 'No image available',
                'You cannot request delivery on a weekend. The next weekday has automatically been chosen.': 'You cannot request delivery on a weekend. The next weekday has automatically been chosen.',
                'Expand all products': 'Expand all products',
                'Collapse all products': 'Collapse all products',

                'The item "%1" has been discontinued and you can therefore not order a higher quantity than what is already available in stock (%2 pcs). Do you want to change the quantity to %2 pcs?': 'The item "%1" has been discontinued and you can therefore not order a higher quantity than what is already available in stock (%2 pcs). Do you want to change the quantity to %2 pcs?',
                'Unavailable quantity': 'Unavailable quantity',

                // Offer error
                'All prices need to be set to download as pdf.': 'All prices need to be set to download as pdf.'
            },
            'sv': {
                'pcs': 'st',
                'Loading...': 'Laddar...',
                'View more': 'Visa mer',
                'Failed to load price for product "%s"': 'Kunde inte ladda pris för "%s"',

                'Sun': 'Sön',
                'Mon': 'Mån',
                'Tue': 'Tis',
                'Wed': 'Ons',
                'Thu': 'Tor',
                'Fri': 'Fre',
                'Sat': 'Lör',

                'January': 'Januari',
                'February': 'Februari',
                'March': 'Mars',
                'April': 'April',
                'May': 'Maj',
                'June': 'Juni',
                'July': 'Juli',
                'August': 'Augusti',
                'September': 'September',
                'October': 'Oktober',
                'November': 'November',
                'December': 'December'
            }
        };
    }
);
